{
  "nl": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Ja, verwijderen",
        "text": "Weet je zeker dat je „{filename}“ wilt verwijderen? Het bestand en de doorzoekbare leerplandoelen worden verwijderd.",
        "title": "Leerplan verwijderen?"
      },
      "configure": "Leerplaninstellingen openen",
      "contextPanel": {
        "loadFailed": "De leerplannen konden niet worden geladen. Probeer het later opnieuw.",
        "manage": "Eigen leerplannen beheren",
        "matching": "Deze leerplannen passen bij de bovenstaande schoolgegevens.",
        "noSubject": "Kies hierboven een vak, dan tonen we je passende leerplannen.",
        "noSubjectMatch": "Voor het gekozen vak hebben we geen leerplannen. Upload je eigen leerplan, dan gebruikt de AI het.",
        "none": "Voor deze gegevens hebben we nog geen leerplan. Upload je eigen leerplan, dan gebruikt de AI het.",
        "notFound": "Voor de bovenstaande gegevens hebben we in {place} geen passend leerplan gevonden. Upload je eigen leerplan, dan gebruikt de AI het.",
        "ownDocument": "eigen document",
        "title": "Leerplannen",
        "unknownRegion": "We kennen je deelstaat niet. Om te voorkomen dat de AI een verkeerd leerplan gebruikt, gebruikt deze er dan geen. Stel je deelstaat in in je profiel.",
        "used": "Op deze leerplannen is dit materiaal gebaseerd.",
        "usedIn": "Op deze leerplannen voor {place} is dit materiaal gebaseerd."
      },
      "coverage": {
        "grades": "Klas {range}",
        "heading": "Jouw vakken in {place}",
        "headingWithoutPlace": "Jouw vakken",
        "openProfile": "Profiel openen",
        "profileIncomplete": "Leg je vakken, schooltype en leerjaren vast in je profiel, dan tonen we je hier de passende leerplannen.",
        "unmapped": "Voor {labels} is er geen eigen leerplan. Upload je eigen leerplan, dan gebruikt de AI het.",
        "editProfile": "Profiel bewerken",
        "own": "Eigen",
        "none": "Geen leerplan voor {place}",
        "noneOtherRegions": "Geen leerplan voor {place}, alleen voor andere deelstaten",
        "uploadHint": "Upload hieronder je eigen.",
        "more": "en {count} andere"
      },
      "delete": "Leerplan verwijderen",
      "deleted": "Leerplan is verwijderd.",
      "deleteFailed": "Leerplan kon niet worden verwijderd.",
      "empty": "Nog geen eigen leerplandocumenten geüpload.",
      "fields": {
        "country": "Land",
        "gradeLevel": "Klasniveau",
        "region": "Regio",
        "schoolType": "Schooltype",
        "subject": "Vak",
        "title": "Titel"
      },
      "intro": "Wij gebruiken de officiële leerplannen uit Duitsland, Oostenrijk en Zwitserland. Daarnaast kun je eigen leerplandocumenten uploaden, bijvoorbeeld een schoolintern curriculum. Als er voor een vak een eigen leerplan bestaat, volgt de AI dat eerst.",
      "loading": "Leerplannen worden geladen...",
      "notSet": "Niet ingesteld",
      "placeholders": {
        "selectOrAddOptions": "Zoeken, selecteren of eigen waarde invoeren"
      },
      "saved": "Leerplanmetadata opgeslagen.",
      "title": "Leerplannen",
      "upload": "Leerplan uploaden",
      "uploaded": "Leerplan is geüpload en wordt verwerkt.",
      "uploadFailed": "Leerplan kon niet worden geüpload.",
      "library": {
        "title": "Leerplannen",
        "subtitle": "Wat voorziet het leerplan voor jouw lessen? Kies land, schooltype, vak en leerjaar of zoek direct naar een onderwerp.",
        "search": {
          "label": "Zoeken in leerplannen",
          "placeholder": "Zoek op onderwerp, term of vaardigheid…",
          "submit": "Zoeken",
          "clear": "Zoekopdracht beëindigen",
          "resultsTitle": "{count} resultaat voor „{query}“ | {count} resultaten voor „{query}“",
          "noResultsTitle": "Geen resultaten voor „{query}“",
          "noResultsText": "Probeer een andere term of verwijder de filters voor vak en leerjaar.",
          "loadFailed": "De zoekopdracht is mislukt. Probeer het opnieuw.",
          "examplesLabel": "Bijvoorbeeld:",
          "examples": "Evolutie, ecosysteem, kwadratische functies, deeltjesmodel, hormonen"
        },
        "filters": {
          "country": "Land",
          "region": "Bondsland",
          "regionCh": "Kanton",
          "allRegions": "Alle regio's",
          "schoolType": "Schooltype",
          "allSchoolTypes": "Alle schooltypen",
          "subject": "Vak",
          "allSubjects": "Alle vakken",
          "yourSubjects": "Jouw vakken",
          "otherSubjects": "Overige vakken",
          "subjectSearch": "Zoek vak…",
          "noDocuments": "nog geen",
          "editProfile": "Profiel bewerken",
          "fromProfileFrame": "Vooraf geselecteerd uit je profiel: {frame}."
        },
        "grades": {
          "title": "Leerjaar",
          "hint": "De balken tonen hoeveel leerplannen er per leerjaar zijn.",
          "selected": "Alleen leerjaar {grade}",
          "showAll": "Alles tonen",
          "gradeLabel": "Leerjaar {grade}, {count} leerplan | Leerjaar {grade}, {count} leerplannen",
          "primary": "Basisonderwijs 1–4",
          "secondaryOne": "Voortgezet onderwijs 5–10",
          "secondaryTwo": "Bovenbouw 11–13",
          "short": "Leerjr."
        },
        "list": {
          "count": "{count} leerplan | {count} leerplannen",
          "read": "Lezen",
          "loadFailed": "De leerplannen konden niet worden geladen. Probeer het opnieuw."
        },
        "empty": {
          "regionTitle": "Voor {place} hebben we nog geen leerplannen",
          "regionText": "We voegen geleidelijk alle landen toe. Het leerplan van jouw school kun je nu al uploaden in de AI-Chat en daar gebruiken.",
          "filterTitle": "Geen leerplannen voor deze selectie",
          "filterText": "Verwijder een filter of kies een ander leerjaar.",
          "unknownFilter": "Deze selectie kennen we niet. Maak een nieuwe keuze."
        },
        "reader": {
          "back": "Leerplannen",
          "original": "Origineel openen",
          "contents": "Inhoud",
          "find": "Zoeken in dit leerplan…",
          "findLabel": "Zoeken in dit leerplan",
          "matches": "{count} sectie | {count} secties",
          "otherGrades": "In andere leerjaren:",
          "hours": "ca. {hours} uur",
          "verbatim": "Tekst uit het officiële leerplan",
          "lostTable": "Hier staat in het origineel een tabel waarvan de inhoud niet kon worden overgenomen. Raadpleeg het origineel.",
          "notFound": "Dit leerplan bestaat niet of niet meer.",
          "chapterTruncated": "Dit hoofdstuk is erg lang en hier ingekort. De volledige tekst vind je in het origineel.",
          "textFailed": "De tekst van dit leerplan kon niet worden geladen. Herlaad de pagina om het opnieuw te proberen.",
          "chapterFailed": "Dit hoofdstuk kon niet worden geladen.",
          "retry": "Opnieuw proberen"
        }
      },
      "ownDocumentsHeading": "Je eigen leerplannen",
      "processing": "Wordt verwerkt … de categorieën verschijnen hier zo.",
      "ready": "Gereed",
      "failed": "Kon niet worden verwerkt.",
      "retry": "Opnieuw proberen",
      "retryFailed": "De verwerking kon niet opnieuw worden gestart."
    }
  }
}
